import * as React from "react";

function IconCreativeCommonsOff({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-creative-commons-off" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/creative-commons-off"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5.638 5.634a9 9 0 1 0 12.723 12.733m1.686 -2.332a9 9 0 0 0 -12.093 -12.077" /><path d="M10.5 10.5a2.187 2.187 0 0 0 -2.914 .116a1.928 1.928 0 0 0 0 2.768a2.188 2.188 0 0 0 2.914 .116" /><path d="M16.5 10.5a2.194 2.194 0 0 0 -2.309 -.302" /><path d="M3 3l18 18" /></svg>;
}

export default IconCreativeCommonsOff;